/** Lab Clear Rates — single updateManyHorse clears all runners (no parallel horseEdit race). */
export function buildClearRatesUpdateManyBody(market: {
  _id: string
  id?: string
  betfairId?: string
}): Record<string, unknown> {
  const betfairId = String(market.betfairId ?? market.id ?? '')
  return {
    marketId: market._id,
    _id: market._id,
    id: betfairId,
    betfairId,
    back: null,
    lay: null,
    ratebuttonData: null,
  }
}
